export interface PopoverPosition {
  left: number;
  top: number;
}

export interface PopoverPositionInput {
  anchor: Pick<DOMRect, 'left' | 'top' | 'right'>;
  popoverWidth: number;
  popoverHeight: number;
  viewportWidth: number;
  viewportHeight: number;
  // Horizontal distance between the anchor's edge and the popover.
  anchorGap: number;
  // Minimum space kept between the popover and every viewport edge.
  viewportMargin: number;
}

// Positions a fixed-position popover beside an anchor rectangle: prefers the
// anchor's right side, flips to the left when the popover would overflow, and
// finally clamps within the viewport margins. Vertically aligns with the
// anchor's top, clamped the same way.
export function computePopoverPosition(input: PopoverPositionInput): PopoverPosition {
  const {
    anchor,
    popoverWidth,
    popoverHeight,
    viewportWidth,
    viewportHeight,
    anchorGap,
    viewportMargin
  } = input;

  let left = anchor.right + anchorGap;
  if (left + popoverWidth > viewportWidth - viewportMargin) {
    left = anchor.left - popoverWidth - anchorGap;
  }
  if (left < viewportMargin) {
    left = Math.max(
      viewportMargin,
      Math.min(anchor.left, viewportWidth - popoverWidth - viewportMargin)
    );
  }

  let top = anchor.top;
  if (top + popoverHeight > viewportHeight - viewportMargin) {
    top = Math.max(viewportMargin, viewportHeight - popoverHeight - viewportMargin);
  }
  if (top < viewportMargin) {
    top = viewportMargin;
  }

  return { left, top };
}
